import { ref, useStore } from '@nuxtjs/composition-api'
// Use require to avoid TS type resolution issues for non-TS module
// eslint-disable-next-line @typescript-eslint/no-var-requires
const Wishlist: any = require('~/assets/ts/items/wishlist').Wishlist

const wishlistItems = ref<string[]>([])
let initialized = false

function ensureLoaded() {
  if (!initialized) {
    new Wishlist().getSlugList().then((items: string[]) => {
      wishlistItems.value = items || []
      initialized = true
    })
  }
}

export function useWishlist() {
  const store = useStore()

  const isInWishlist = (slug: string) => {
    return wishlistItems.value.includes(slug)
  }

  const add = async (slug: string) => {
    await new Wishlist().add(slug)
    if (!wishlistItems.value.includes(slug)) {
      wishlistItems.value.push(slug)
    }
    if (store) {
      store.commit('wishlist/increase')
    }
  }

  const remove = async (slug: string) => {
    await new Wishlist().remove(slug)
    wishlistItems.value = wishlistItems.value.filter((s) => s !== slug)
    if (store) {
      store.commit('wishlist/decrease')
    }
  }

  const toggle = async (slug: string) => {
    if (isInWishlist(slug)) {
      await remove(slug)
    } else {
      await add(slug)
    }
  }

  return {
    wishlistItems,
    isInWishlist,
    add,
    remove,
    toggle,
    load: ensureLoaded,
  }
}
